import { EntityList } from "@dash/entity-list";
import { Button } from "@dash/form";
import { Page, PageHeader } from "@dash/page";
import { Pagination } from "@dash/search";
import { QuerySkeleton } from "@dash/skeleton";
import { useEffect, useState } from "react";
import { MdAdd, MdRefresh } from "react-icons/md";

import { CodeGenerationOrder } from "@megaron/loyalty-points-contracts";
import { useClientManager } from "@megaron/react-clients";

import { NewCodeGenerationOrderDialog } from "./NewCodeGenerationOrderDialog";

const orderStatus = (order: CodeGenerationOrder, now: number) => {
  if (order.fulfilledAt) return "Zrealizowane";
  if (order.validUntil.getTime() < now) return "Wygasłe";
  return "Oczekujące";
};

export const CodeGenerationOrdersHome = () => {
  const [isCreating, setIsCreating] = useState(false);
  const [page, setPage] = useState(0);
  const [now, setNow] = useState(Date.now);
  const pageSize = 20;
  const query = useClientManager("loyaltyPoints").codeGenerationOrdersQuery().useQuery({}, { refetchInterval: 30000 });

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <Page>
      <PageHeader
        actions={
          <div css={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
            <Button size="small" variant="outline" icon={<MdRefresh />} onClick={() => query.refetch()}>
              Odśwież
            </Button>
            <Button size="small" icon={<MdAdd />} onClick={() => setIsCreating(true)}>
              Nowe zlecenie generowania kodów
            </Button>
          </div>
        }
      >
        Zlecenia generowania kodów
      </PageHeader>
      <QuerySkeleton query={query}>
        {(orders) => (
          <>
            {orders.length === 0 ? (
              <p>Brak zleceń generowania kodów.</p>
            ) : (
              <EntityList
                items={[...orders]
                  .sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime())
                  .slice(page * pageSize, (page + 1) * pageSize)}
                getKey={(order) => order.id}
                columns={(order) => [
                  { header: "Grupa", content: order.groupName, isPrimary: true },
                  { header: "Status", content: orderStatus(order, now) },
                  { header: "Liczba kodów", content: order.quantity.toLocaleString("pl-PL") },
                  { header: "Utworzono", content: order.createdAt.toLocaleString("pl-PL") },
                  { header: "Ważne do", content: order.validUntil.toLocaleString("pl-PL") },
                  { header: "Zrealizowano", content: order.fulfilledAt?.toLocaleString("pl-PL") ?? "—" },
                  { header: "ID zlecenia generowania kodów", content: order.id },
                ]}
              />
            )}
            <Pagination page={page} onPageChange={setPage} pageSize={pageSize} itemCount={orders.length} />
          </>
        )}
      </QuerySkeleton>
      {isCreating && (
        <NewCodeGenerationOrderDialog
          onClose={() => setIsCreating(false)}
          onCreated={() => {
            setPage(0);
            setIsCreating(false);
          }}
        />
      )}
    </Page>
  );
};
